import { Json, JsonObject, isJsonObject } from '@se/cp.common';

const jsonToXml = (obj: Json, tag: string) => {
    let xml: string = '';
    if (typeof obj === 'object' && !Array.isArray(obj) && obj !== null) {
        for (let key in obj) {
            const child = obj[key];
            if (Array.isArray(child)) {
                for (let item of child as Array<JsonObject>) {
                    xml += jsonToXml(item, key);
                }
            } else {
                xml += `${jsonToXml(child, key)}`;
            }
        }
    } else {
        xml += obj;
    }
    if (tag) {
        xml = `<${tag}>${xml}</${tag}>`;
    }
    return xml;
};

export const jsonToSoap = (
    input: JsonObject,
    xmlns: Record<string, string> = {
        soap: 'http://www.w3.org/2003/05/soap-envelope',
    },
): string => {
    const nameSpaces = Object.entries(xmlns)
        .map(([key, url]) => `xmlns:${key}="${url}"`)
        .join(' ');
    // Avvolgiamo il risultato in un nodo radice soap
    return `<soap:Envelope ${nameSpaces}>
                <soap:Header/>
                ${jsonToXml(input, 'soap:Body')}
            </soap:Envelope>`;
};

const nodeToJson = (node: Element): Json => {
    if (node.nodeType === Node.TEXT_NODE) {
        return node.nodeValue?.trim() ?? '';
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
        if (!node.children.length) {
            return node.textContent?.trim() ?? '';
        }
        const answer: JsonObject = {};
        for (let child of node.children) {
            const childJson = nodeToJson(child);
            const key = child.nodeName;
            if (answer[key]) {
                if (!Array.isArray(answer[child.nodeName])) {
                    answer[child.nodeName] = [answer[child.nodeName]];
                }
                (answer[child.nodeName] as Array<Json>).push(childJson ?? '');
            } else {
                answer[key] = childJson;
            }
        }
        return answer;
    }
    return '';
};

export const soapToJson = (input: string): Json => {
    const parser = new DOMParser();
    const soapDoc = parser.parseFromString(input, 'text/xml');
    soapDoc.documentElement;
    const json = nodeToJson(soapDoc.documentElement);
    return isJsonObject(json) ? json : {};
};
